// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__30v-m","savePackageButton":"ClientWallet_savePackageButton__1ZInz"};